import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { booleanFlagValue, UserRoles } from 'src/latest/src/constants';
import { billingAdminRoutes } from 'src/latest/src/routes';
import './BillingAdminDashboard.scss';

export const BillingAdminDashboard: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loggedInUser } = useSelector((state: any) => state.authentication);
  const configuration = useSelector((state: any) => state.configuration);

  useEffect(() => {
    const role = loggedInUser?.userRole?.toUpperCase();

    if (configuration?.billingDashboardEnabled === booleanFlagValue.FALSE) {
      navigate('/', { replace: true });
    } else {
      switch (role) {
        case UserRoles.BILLING:
          break;

        case UserRoles.CLIENT:
          navigate('/therapy/client', { replace: true });
          break;

        case UserRoles.THERAPIST:
          navigate('/therapy/therapist', { replace: true });
          break;

        case UserRoles.PRACTICE_ADMIN:
          navigate('/practice-admin', { replace: true });
          break;

        case UserRoles.SCHEDULER:
          navigate('/therapy/scheduler', { replace: true });
          break;

        case UserRoles.TENANT_SUPER_ADMIN:
          navigate('/super-admin', { replace: true });
          break;

        default:
          navigate('/', { replace: true });
          break;
      }
    }
  }, [loggedInUser, navigate, location]);

  return (
    <div className="billing-admin-dashboard">
      <Routes>
        <Route index={true} element={<Navigate to="home" replace={true} />} />

        {billingAdminRoutes?.map(route => (
          <Route
            path={route.path}
            element={
              <div className="billing-admin-dashboard-content-container">
                <route.component />
              </div>
            }
            key={route.path}
          />
        ))}
      </Routes>
    </div>
  );
};
